module.exports = __webpack_public_path__ + "static/media/cate-market.b46d3725.png";